export const COLOR_BLACK = '#000';
export const COLOR_GRAY = '#050505';
export const COLOR_WHITE = '#fff';
